 import { FC, ReactNode } from "react";
import { Card } from "../UIKits/Cards/Card";

interface DashboardCardProps {
  children: ReactNode;
  className?: string;
  gradient: "green" | "white" | "ash";
}

export const DashboardCard: FC<DashboardCardProps> = ({ 
  children, 
  className = "", 
  gradient
}) => {
  const gradientClasses = {
    green: "bg-custom-gradient",
    white: "bg-white-gradient",
    ash: "bg-ashbg"
  };

  return (
    <Card 
      className={`flex justify-between  ${gradientClasses[gradient]} ${className}`}
      rounded="2xl"
      padding="none"
    >
      {children}
    </Card>
  );
};
